import { data } from '../../svg/DragIndicator/data';
import { makeIcon } from '../makeIcon';

export const DragIndicator = makeIcon(data, 'drag_indicator', 'DragIndicator');

export default DragIndicator;
